export default __webpack_public_path__ + "static/media/profile.9798dc5b.jpeg";